import Dashboard from './container/index';

export default Dashboard;


// WEBPACK FOOTER //
// ./src/views/Dashboard/index.jsx